import { AjaxifyGrid, AjaxifyGrid_CoreInit, Carousel, Carousel_CoreInit, Accordion, Popup, Form, Form_CoreInit, Burger, Mobile, Scrollbar, Header_CoreInit } from './core'
import Header from './modules/header'
import Favorites from './modules/favorites'
import { Demande_FormOptions } from './modules/demande'
import FormFunctions from './modules/form'
import { carouselConfigs } from './modules/carousel-config'

AjaxifyGrid_CoreInit([
  {
    classSelector: 'grid--postitem__attachment',
    afterUpdate: function(grid) {
      Lightbox_PluginInit()
      if ($.mlmi.favorites) {
        $.mlmi.favorites.buttons(grid[0])
      }
    },
    afterReplace: function(grid) {
      Lightbox_PluginInit()
      if ($.mlmi.favorites) {
        $.mlmi.favorites.buttons(grid[0])
      }
    },
  },
  {
    classSelector: 'grid--postitem__product',
    afterUpdate: function(grid) {
      grid.find('.carousel:not(.swiper-container)').each(function() {
        Carousel_CoreInit([
          {
            classSelector: 'carousel--style--gallery',
            swiperOptions: {
              ...window.Carousel_Gallery(),
            },
          },
        ], $(this).closest('.grid__item'))
      })
      grid.wrapper.css('max-height', grid.outerHeight() + 'px');
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
        // Fixes fixed content
      }, 300);
      if ($.mlmi.favorites) {
        $.mlmi.favorites.buttons(grid[0])
      }
    },
    afterReplace: function(grid) {
      Carousel_CoreInit([
        {
          classSelector: 'carousel--style--gallery',
          swiperOptions: {
            ...window.Carousel_Gallery(),
          },
        },
      ], grid)
      grid.wrapper.css('max-height', grid.outerHeight() + 'px');
      if ($.mlmi.favorites) {
        $.mlmi.favorites.buttons(grid[0])
      }
    },
  },
])

Carousel_CoreInit(carouselConfigs)

Form_CoreInit([
  {
    classSelector: 'builder-form',
    formOptions: {
      floating_labels: true,
      file_input: true,
      date_picker: {
        dateFormat: "dd/mm/yy",
        nextText: '',
        prevText: '',
        minDate: 1,
        maxDate: '+24M',
      },
    },
  },
  {
    classSelector: 'builder-form--demande',
    formOptions: Demande_FormOptions(),
  },
  {
    classSelector: 'builder-form--demande-prix',
    formOptions: Demande_FormOptions(),
  },
])

Header_CoreInit({
  burger_options: {
    onToggle: function() {
      if (!$('body').hasClass('--menu-open')) {
        //opening
        $('.header__mobile-menu-items .main-menu__item--parent.--opened').removeClass('--opened')
      }
      $('body').toggleClass('--menu-open')
    },
  }
})

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
    favorites: undefined,
    history: undefined,
  }

  /* Accordéons */
  Accordion.init();

  /* Favorites */
  Favorites.init()

  $('.accordion-content__image picture').each(function() {
    var toggle = $(this).closest('.js-accordion__item').find('.js-accordion__header .accordion__header-title');
    toggle.after($(this).clone())
  })

  /* Popups */
  Popup.init()

  /* Fixed content */
  FixedContent_PluginInit()

  /* Buttons - Must be before Lightbox */
  $('.btn-primary, .btn-secondary, .secondary-menu__link, .field__submit, .btn-tag, .text-tag, .ajax-load-more__btn, .card-custom__cta').each(function() {
    $(this).html('<span>' + $(this).html() + '</span>');
  })

  /* Lightbox */
  Lightbox_PluginInit()


  /* Post Share */
  PostShare_PluginInit()

  /* Header */
  Header.init()

  /* Header search */
  HeaderSearch_PluginInit()

  /* Video loop */
  VideoLoop_PluginInit()

  /* Form Functions */
  FormFunctions.init()

  /* Buttons */
  $('.text-content a[class*=btn-]').each(function() {
    if ($(this).parent().is('p')) {
      if ($(this).parent().children().length === $(this).parent().find('a[class*=btn-]').length) {
        $(this).parent().contents().wrapAll('<div class="btn-wrapper"></div>');
      }
    }
  })

  /* Responsive Table */
  $('.text-content table').each(function() {
    $(this).wrap('<div class="responsive-table"></div>')
  })

  var table_scrollbar = new Scrollbar('.responsive-table', {
    direction: 'horizontal',
    desktop: true,
    mobile: true,
  })

  $('.btn-cursor').each(function() {
    $(this).css({
      '--title': '"' + $(this).attr('data-title') + '"',
    })
    $(this).find('a[title]').attr('title', '')
  });

  $(document).on('mousemove', function(e) {
    $('.btn-cursor').each(function() {
      if ($(this).hasClass('card-home-slider')) {
        $(this).css({
          '--left': (e.clientX - $(this).offset().left) + 'px',
          '--top': (e.clientY - $(this).offset().top + $(window).scrollTop()) + 'px',
        })
      }
    })
  });

  $('.js-ajaxify-grid-item:not(.reset)').click(function() {
    $(this).closest('.grid-header').find('.grid-filters__global-reset').removeClass('--selected')
  });

  $('.grid-filters__global-reset').click(function() {
    $(this).addClass('--selected')
    $(this).closest('.grid-header').find('.reset').trigger('click')
  });

  $('.account__save-btn').click(function() {
    $(this).closest('.account__section-header').nextAll('form').find('.field__submit').trigger('click')
  });

  $('.form-container__content').each(function() {
    $(this).scrollbar = new Scrollbar($(this), {
      direction: 'vertical',
      desktop: true,
      mobile: true,
    })
  })
})
